define('_pubsub',[
    'underscore'
], function(_) {
    'use strict';
    
    var oInstance;

    var oPubsub=function() {
        if(oInstance) {
            return oInstance;
        }
        oInstance=this;

        this.on=function(ev, fn)
        {
            if(true===_.isFunction(fn)) {
                this.oListeners[ev].push(fn);
            }
        };

        this.remove=function(ev, fn)
        {
            if(true===_.isFunction(fn)) {
                this.oListeners[ev]=_.without(this.oListeners[ev], _.findWhere(this.oListeners[ev], fn));
            }
        };

        this.trigger=function(ev, data)
        {
            _.each(this.oListeners[ev], function(fn)
            {
                fn(data);
            });
        };

        this.oListeners={
            RESIZE_FLICKITY:[],
            ISOTOPE_UPDATED:[],
            UPDATE_ISOTOPE:[],
            REMOVE_ISOTOPE:[],
            RESIZE:[],
            SCROLL:[],
            SCROLL_DELTA:[],
            DISABLE_SCROLL_UI:[],
            TRIGGER_TOGGLE_TILEWALL:[],
            TILEWALL_ADD_ITEM: [],
            CREATE_BRIGHTCOVE_PLAYER:[],
            REMOVE_BRIGHTCOVE_PLAYER:[],
            VIEWPORT_CHANGE:[],
            DEEPLINK_GOTO:[],
            FLICKITY_STATICCLICK:[],
            CREATE_VIMEO_PLAYER:[],
            CREATE_YOUTUBE_PLAYER:[],
            PLAY_VIDEO:[],
            UPDATE_FLICKITY_BY_ID:[],
            DESTROY_FLICKITY_BY_ID:[],
            FLICKITY_ADD_ELEMENT:[],
            LIGHTBOX_SHOW : [],
            INIT_VIDEO : [],
            DELETE_VIDEO: [],
            DISPOSE_YOUTUBE_PLAYER : [],
            LIGHTBOX_SET_CONTENT : [],
            LIGHTBOX_UPDATE_CONTENT: [],
            HIDE_NL_POPUP: []
        };
    };

    //listener identifier
    oPubsub.RESIZE_FLICKITY='RESIZE_FLICKITY';
    oPubsub.ISOTOPE_UPDATED='ISOTOPE_UPDATED';
    oPubsub.UPDATE_ISOTOPE='UPDATE_ISOTOPE';
    oPubsub.REMOVE_ISOTOPE='REMOVE_ISOTOPE';
    oPubsub.RESIZE='RESIZE';
    oPubsub.SCROLL='SCROLL';
    oPubsub.SCROLL_DELTA='SCROLL_DELTA';
    oPubsub.DISABLE_SCROLL_UI='DISABLE_SCROLL_UI';
    oPubsub.TRIGGER_TOGGLE_TILEWALL='TRIGGER_TOGGLE_TILEWALL';
    oPubsub.TILEWALL_ADD_ITEM='TILEWALL_ADD_ITEM';
    oPubsub.CREATE_BRIGHTCOVE_PLAYER='CREATE_BRIGHTCOVE_PLAYER';
    oPubsub.REMOVE_BRIGHTCOVE_PLAYER='REMOVE_BRIGHTCOVE_PLAYER';
    oPubsub.VIEWPORT_CHANGE='VIEWPORT_CHANGE';
    oPubsub.DEEPLINK_GOTO='DEEPLINK_GOTO';
    oPubsub.FLICKITY_STATICCLICK='FLICKITY_STATICCLICK';
    oPubsub.CREATE_VIMEO_PLAYER='CREATE_VIMEO_PLAYER';
    oPubsub.CREATE_YOUTUBE_PLAYER='CREATE_YOUTUBE_PLAYER';
    oPubsub.PLAY_VIDEO='PLAY_VIDEO';
    oPubsub.UPDATE_FLICKITY_BY_ID='UPDATE_FLICKITY_BY_ID';
    oPubsub.DESTROY_FLICKITY_BY_ID='DESTROY_FLICKITY_BY_ID';
    oPubsub.FLICKITY_ADD_ELEMENT='FLICKITY_ADD_ELEMENT';
    oPubsub.LIGHTBOX_SHOW = 'LIGHTBOX_SHOW';
    oPubsub.INIT_VIDEO = 'INIT_VIDEO';
    oPubsub.DISPOSE_YOUTUBE_PLAYER = 'DISPOSE_YOUTUBE_PLAYER';
    oPubsub.DELETE_VIDEO = 'DELETE_VIDEO';
    oPubsub.LIGHTBOX_SET_CONTENT = 'LIGHTBOX_SET_CONTENT';
    oPubsub.LIGHTBOX_UPDATE_CONTENT = 'LIGHTBOX_UPDATE_CONTENT';
    oPubsub.HIDE_NL_POPUP = 'HIDE_NL_POPUP';

    return oPubsub;
});
